import React from 'react';
import './Process.css';

const Process = () => {
  const steps = [
    {
      number: '1',
      icon: <img src="/images/process/trans-consultation.svg" alt="Consultation" />,
      title: 'Consultation',
      description: 'We begin by understanding your specific needs and requirements to tailor our solutions to your vision.'
    },
    {
      number: '2',
      icon: <img src="/images/process/trans-quote.svg" alt="Quote" />,
      title: 'Quote',
      description: 'Based on the consultation, we provide a clear, detailed quote outlining the cost and scope of the project.'
    },
    {
      number: '3',
      icon: <img src="/images/process/trans-design.svg" alt="Design" />,
      title: 'Design',
      description: 'After approval, we create a custom design that aligns with your preferences and the functionality you need.'
    },
    {
      number: '4',
      icon: <img src="/images/process/trans-installation.svg" alt="Installation" />,
      title: 'Installation',
      description: 'We begin by understanding your specific needs and requirements to tailor our solutions to your vision.'
    }
  ];

  return (
    <section className="process-section">
      <div className="process-container">
        <h2>Get to know our process</h2>
        
        <div className="process-steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step-content">
                <span className="step-number">{step.number}</span>
                <div className="step-info">
                  <div className="step-icon">{step.icon}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="process-line"></div>

        <div className="clients-section">
          <h2>JOIN OUR SATISFIED CLIENTS</h2>
          <p>As East Africa's Leading Premier Tent Manufacturer<br />We are proud to have earned the trust of these top brands and companies.</p>
          
          <div className="client-logos">
            <img src="/images/partiners/myo.svg" alt="Moyo" />
            <img src="/images/partiners/singita.svg" alt="Singita" />
            <img src="/images/partiners/malaika.svg" alt="Malaika Camps & Lodges" />
            <img src="/images/partiners/legendary.svg" alt="client Wetu" />
            <img src="/images/partiners/asilia.svg" alt="Asilia" />
            <img src="/images/partiners/tato.svg" alt="Tato" />
            <img src="/images/partiners/mgunga.svg" alt="Mgunga" />
            <img src="/images/partiners/kifaru.svg" alt="Kifaru" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;